/**
 * 销售管理 员工工作平台 mock
 * http://mockjs.com/
 url： https://testzsqy.cheanjia.com/?mock=1#/sms/4
 */
import Mock from 'mockjs'
import cache from '../../common/cache'

let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'
// 枚举表
Mock.mock(/sale_potential_customer\/enums/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'arrive_type': [
      {
        'key': '1',
        'value': 'FloorUp'
      },
      {
        'key': '2',
        'value': 'PhoneUp'
      },
      {
        'key': '3',
        'value': 'net'
      },
      {
        'key': '4',
        'value': 'Referral'
      }
    ],
    'buy_type': [
      {
        'key': '1',
        'value': '初购'
      }, {
        'key': '2',
        'value': '添购'
      }, {
        'key': '3',
        'value': '换购'
      }
    ],
    'car_color': [
      {
        'key': '1',
        'value': '白色'
      },
      {
        'key': '2',
        'value': '橙色'
      },
      {
        'key': '3',
        'value': '灰色'
      },
      {
        'key': '4',
        'value': '黑色'
      },
      {
        'key': '5',
        'value': '棕色'
      },
      {
        'key': '6',
        'value': '黄色'
      },
      {
        'key': '7',
        'value': '香槟色'
      },
      {
        'key': '8',
        'value': '蓝色'
      },
      {
        'key': '9',
        'value': '绿色'
      },
      {
        'key': '10',
        'value': '紫色'
      },
      {
        'key': '11',
        'value': '红色'
      }
    ],
    'channel_type': [
      {
        'key': '1',
        'value': '网络渠道'
      }, {
        'key': '2',
        'value': '单页派发'
      }, {
        'key': '3',
        'value': '客服招揽'
      }, {
        'key': '4',
        'value': '广告牌'
      }, {
        'key': '5',
        'value': '电台广告'
      }, {
        'key': '6',
        'value': '老客户介绍'
      }, {
        'key': '7',
        'value': '老客户再购'
      }, {
        'key': '8',
        'value': '曾经来店'
      }, {
        'key': '9',
        'value': '道栅广告'
      }, {
        'key': '10',
        'value': '电梯广告'
      }, {
        'key': '11',
        'value': '自店短信'
      }, {
        'key': '12',
        'value': '银行短信'
      }, {
        'key': '13',
        'value': '车身贴'
      }, {
        'key': '14',
        'value': '车牌框'
      }, {
        'key': '15',
        'value': '车展/外展'
      }, {
        'key': '16',
        'value': '114查询'
      }, {
        'key': '17',
        'value': '12580查询'
      }, {
        'key': '18',
        'value': '电影贴片'
      }
    ],
    'customer_note_type': [
      {
        'code': 1,
        'name': 'string'
      }
    ],
    'fail_reason': [
      {
        'key': '1',
        'value': '客户说没有留资或打错'
      }, {
        'key': '2',
        'value': '距离本店太远，不愿到店'
      }, {
        'key': '3',
        'value': '无法再联系到客户'
      }, {
        'key': '4',
        'value': '车辆存在不满意的方面'
      }, {
        'key': '5',
        'value': '车价超出客户预算'
      }, {
        'key': '6',
        'value': '电话无法接通或无人接听'
      }, {
        'key': '7',
        'value': '价格较其它品牌高'
      }, {
        'key': '8',
        'value': '客户没有说明原因'
      }, {
        'key': '9',
        'value': '二级网点咨询'
      }, {
        'key': '10',
        'value': '客户不接受加价或加精品'
      }, {
        'key': '11',
        'value': '客户要求上外地牌'
      }, {
        'key': '12',
        'value': '咨询售后业务'
      }, {
        'key': '13',
        'value': '无现车或交车期过长'
      }, {
        'key': '14',
        'value': '无居住证，无法上东莞牌'
      }, {
        'key': '15',
        'value': '客户对服务不满意'
      }, {
        'key': '16',
        'value': '同品牌4S店留资或来电'
      }, {
        'key': '17',
        'value': '按揭无法办理'
      }, {
        'key': '18',
        'value': '二手车置换不成功'
      }, {
        'key': '19',
        'value': '客户暂缓购车计划'
      }
    ],
    'from_type': [
      {
        'key': '1',
        'value': '400来电'
      },
      {
        'key': '2',
        'value': '总机来电'
      },
      {
        'key': '3',
        'value': '手机来电'
      }
    ],
    'intention_level': [
      {
        'key': '1',
        'value': 'O'
      },
      {
        'key': '2',
        'value': 'A'
      },
      {
        'key': '3',
        'value': 'B'
      },
      {
        'key': '4',
        'value': 'C'
      },
      {
        'key': '5',
        'value': 'D'
      },
      {
        'key': '6',
        'value': 'F'
      },
      {
        'key': '7',
        'value': 'H'
      }
    ],
    'pay_type': [
      {
        'key': '1',
        'value': '全款'
      }, {
        'key': '2',
        'value': '分期'
      }, {
        'key': '3',
        'value': '先全款后分期'
      }
    ],
    'priority': [
      {
        'code': 1,
        'name': '高'
      }
    ],
    'sub_channel_type': [
      {
        'key': '1',
        'value': '厂家官网'
      }, {
        'key': '2',
        'value': '汽车之家'
      }, {
        'key': '3',
        'value': '易车网'
      }, {
        'key': '4',
        'value': '爱卡网'
      }, {
        'key': '5',
        'value': '太平洋网'
      }, {
        'key': '6',
        'value': '东莞汽车网'
      }, {
        'key': '7',
        'value': '车主之家'
      }, {
        'key': '8',
        'value': '网上车市'
      }, {
        'key': '9',
        'value': '凤凰网'
      }, {
        'key': '10',
        'value': '新浪网'
      }, {
        'key': '11',
        'value': '腾讯网'
      }, {
        'key': '12',
        'value': '微信留资'
      }, {
        'key': '13',
        'value': '公司微博'
      }, {
        'key': '14',
        'value': '车载导航'
      }, {
        'key': '15',
        'value': '手机导航'
      }
    ],
    'user_type': [
      {
        'code': 1,
        'name': 'string'
      }
    ]
  },
  'message': 'ok'
})

// 员工数据统计
Mock.mock(/sale_potential_customer\/staff_work_summary/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'book_today_customer_and_clue_num': 10,
    'clue_num': 20,
    'customer_num': 30,
    'customer_task_num': 40,
    'pending_follow_up_clue_num': 50,
    'today_customer_task_num': 60,
    'today_pending_follow_up_clue_num': 70,
    'today_store_visit_num': 80
  },
  'message': 'ok'
})

// 预约到店-客户列表
Mock.mock(/sale_potential_customer\/today_book_customer/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'customers': [
      {
        'next_arrive_at': '2016-10-17 10:30:33',
        'customer_name': '客户-哇哈哈',
        'id': 11,
        'intention_cars': [
          {
            'car_model': '二二温热我认为认为',
            'inner_color': '红色',
            'outer_color': '白色'
          },
          {
            'car_model': '232423dfafdsff',
            'inner_color': '红色',
            'outer_color': '白色'
          }
        ],
        'intention_level': 'B',
        'last_contract_at': '2016-10-17 10:30:33',
        'mobile': '15002056658',
        'next_contact': '2016-10-17',
        'store_visit_num': 20
      }, {
        'next_arrive_at': '2016-10-17 10:30:33',
        'customer_name': '客户-哇哈哈2',
        'id': 12,
        'intention_cars': [
          {
            'car_model': '二二温热我认为认为',
            'inner_color': '红色',
            'outer_color': '白色'
          },
          {
            'car_model': '232423dfafdsff',
            'inner_color': '红色',
            'outer_color': '白色'
          }
        ],
        'intention_level': 'B',
        'last_contract_at': '2016-10-17 10:30:33',
        'mobile': '15002056658',
        'next_contact': '2016-10-17',
        'store_visit_num': 20
      }, {
        'next_arrive_at': '2016-10-17 10:30:33',
        'customer_name': '客户-哇哈哈3',
        'id': 13,
        'intention_cars': [
          {
            'car_model': '二二温热我认为认为',
            'inner_color': '红色',
            'outer_color': '白色'
          },
          {
            'car_model': '232423dfafdsff',
            'inner_color': '红色',
            'outer_color': '白色'
          }
        ],
        'intention_level': 'B',
        'last_contract_at': '2016-10-17 10:30:33',
        'mobile': '15002056658',
        'next_contact': '2016-10-17',
        'store_visit_num': 20
      }, {
        'next_arrive_at': '2016-10-17 10:30:33',
        'customer_name': '客户-哇哈哈4',
        'id': 0,
        'intention_cars': [
          {
            'car_model': '二二温热我认为认为',
            'inner_color': '红色',
            'outer_color': '白色'
          },
          {
            'car_model': '232423dfafdsff',
            'inner_color': '红色',
            'outer_color': '白色'
          }
        ],
        'intention_level': 'B',
        'last_contract_at': '2016-10-17 10:30:33',
        'mobile': '15002056658',
        'next_contact': '2016-10-17',
        'store_visit_num': 20
      }
    ],
    'total': 110
  },
  'message': 'ok'
})

// 预约到店-线索列表
Mock.mock(/sale_potential_customer\/today_book_clue/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'clues': [
      {
        'next_arrive_at': '2016-10-17 10:30:33',
        'customer_name': '线索-哇哈哈',
        'id': 1,
        'intention_cars': [
          {
            'car_model': '放大发送打发打发撒短发散发',
            'inner_color': '红色',
            'outer_color': '黑色'
          },
          {
            'car_model': '反对打发打发打发打发撒发生',
            'inner_color': '紫色',
            'outer_color': '黑色'
          }
        ],
        'mobile': '15002056659',
        'next_contact': '2016-10-17'
      },
      {
        'next_arrive_at': '2016-10-17 10:30:33',
        'customer_name': '线索-哇哈哈2',
        'id': 1,
        'intention_cars': [
          {
            'car_model': '放大发送打发打发撒短发散发',
            'inner_color': '红色',
            'outer_color': '黑色'
          },
          {
            'car_model': '反对打发打发打发打发撒发生',
            'inner_color': '紫色',
            'outer_color': '黑色'
          }
        ],
        'mobile': '15002056659',
        'next_contact': '2016-10-17'
      }, {
        'next_arrive_at': '2016-10-17 10:30:33',
        'customer_name': '线索-哇哈哈3',
        'id': 1,
        'intention_cars': [
          {
            'car_model': '放大发送打发打发撒短发散发',
            'inner_color': '红色',
            'outer_color': '黑色'
          },
          {
            'car_model': '反对打发打发打发打发撒发生',
            'inner_color': '紫色',
            'outer_color': '黑色'
          }
        ],
        'mobile': '15002056659',
        'next_contact': '2016-10-17'
      }, {
        'next_arrive_at': '2016-10-17 10:30:33',
        'customer_name': '线索-哇哈哈4',
        'id': 1,
        'intention_cars': [
          {
            'car_model': '放大发送打发打发撒短发散发',
            'inner_color': '红色',
            'outer_color': '黑色'
          },
          {
            'car_model': '反对打发打发打发打发撒发生',
            'inner_color': '紫色',
            'outer_color': '黑色'
          }
        ],
        'mobile': '15002056659',
        'next_contact': '2016-10-17'
      }, {
        'next_arrive_at': '2016-10-17 10:30:33',
        'customer_name': '线索-哇哈哈5',
        'id': 1,
        'intention_cars': [
          {
            'car_model': '放大发送打发打发撒短发散发',
            'inner_color': '红色',
            'outer_color': '黑色'
          },
          {
            'car_model': '反对打发打发打发打发撒发生',
            'inner_color': '紫色',
            'outer_color': '黑色'
          }
        ],
        'mobile': '15002056659',
        'next_contact': '2016-10-17'
      }
    ],
    'total': 960
  },
  'message': 'ok'
})

// 预约到店-线索档案详情
Mock.mock(/sale_potential_customer\/clue\/\d+$/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'address': 'string',
    'channel_type': 1,
    'city': '太原市',
    'city_code': '310200',
    'contrast_cars': [
      {
        'model_id': 0,
        'model_name': 'string'
      }
    ],
    'creator': 'string',
    'customer_name': 'string',
    'district': '小店区',
    'district_code': '310200--',
    'from_type': 3,
    'id': 0,
    'intention_cars': [
      {
        'car_model_id': 1,
        'car_model_name': '啊啊啊啊啊啊111',
        'inner_color': 1,
        'outer_color': 2
      },
      {
        'car_model_id': 2,
        'car_model_name': '啊啊啊啊啊啊222',
        'inner_color': 2,
        'outer_color': 3
      }
    ],
    'mobile': 'string',
    'next_arrive_at': '2016-10-17 10:30:33',
    'next_contact_at': '2016-10-17',
    'notes': [
      {
        'created_at': '2016-10-17 10:30:33',
        'remark': '1111111111111111111111111111111'
      },
      {
        'created_at': '2016-10-17 10:30:33',
        'remark': '22222222222222222222222'
      }
    ],
    'priority': 0,
    'province': '山西省',
    'province_code': '310000',
    'sub_channel_type': 4,
    'user_type': 0
  },
  'message': 'ok'
})

// 添加线索跟进记录
Mock.mock(/sale_potential_customer\/clue_note/, 'post' + mockSwitch, {
  'code': 0,
  'data': {},
  'message': 'ok'
})

// 今日到店客流
Mock.mock(/sale_potential_customer\/today_store_visit/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'total': 100,
    'visits': [
      {
        'arrive_at': '2017-10-17 10:30:33',
        'customer_name': '哇哈哈1',
        'id': 1,
        'is_invited': 0,
        'mobile': '',
        'relate_customer_id': '',
        'is_test_drive': 1,
        'leaved_at': '2017-10-17 10:40:33'
      },
      {
        'arrive_at': '2017-10-17 10:30:33',
        'customer_name': '哇哈哈2',
        'id': 2,
        'is_invited': 0,
        'mobile': '15002056651',
        'relate_customer_id': null,
        'is_test_drive': 0,
        'leaved_at': '0'
      },
      {
        'arrive_at': '2017-10-17 10:30:33',
        'customer_name': '哇哈哈3',
        'id': 3,
        'is_invited': 1,
        'mobile': '15002056653',
        'relate_customer_id': 2,
        'is_test_drive': 1,
        'leaved_at': '2017-08-16 17:22:33'
      },
      {
        'arrive_at': '2017-10-17 10:30:33',
        'customer_name': '哇哈哈4',
        'id': 4,
        'is_invited': 0,
        'mobile': 'string',
        'relate_customer_id': 1
      },
      {
        'arrive_at': '2017-10-17 10:30:33',
        'customer_name': '15002056654',
        'id': 5,
        'is_invited': 0,
        'mobile': 'string',
        'relate_customer_id': 1
      }
    ]
  },
  'message': 'ok'
})

// 今日到店客流--客户详情
Mock.mock(/sale_potential_customer\/customers\/\d+$/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'address': 'string',
    'channel_type': 1,
    'city': '深圳市',
    'city_code': '140100',
    'contrast_cars': [
      {
        'car_model_id': 1,
        'car_model_name': '宝马 X6'
      },
      {
        'car_model_id': 2,
        'car_model_name': '保时捷卡宴'
      }
    ],
    'creator': 'string',
    'customer_name': 'string',
    'district': '南山区',
    'district_code': '140106',
    'first_arrive_at': '2017-10-17 10:30:33',
    'first_arrive_type': 3,
    'id': 0,
    'intention_cars': [
      {
        'car_model_id': 1,
        'car_model_name': '啊啊啊啊啊啊111',
        'inner_color': 1,
        'outer_color': 2
      },
      {
        'car_model_id': 2,
        'car_model_name': '啊啊啊啊啊啊222',
        'inner_color': 2,
        'outer_color': 3
      }
    ],
    'intention_level': '3',
    'last_contact_at': '2017-10-17 10:30:33',
    'mobile': 'string',
    'next_arrive_at': '2017-10-17 10:30:33',
    'next_contact_at': '2017-10-17',
    'notes': [{
      'call_duration': 11,
      'created_at': '2017-10-17 10:30:33',
      'intention_level': 'A',
      'remark': 'DKALDLLFLDFFFFFFFDSAFDAFDAFASFDSL'
    }, {
      'call_duration': 11,
      'created_at': '2017-10-17 10:30:33',
      'intention_level': 'A',
      'remark': 'DKALDLLFLDFFFFFFFDSAFDAFDAFASFDSL'
    }, {
      'call_duration': 11,
      'created_at': '2017-10-17 10:30:33',
      'intention_level': 'B',
      'remark': 'DKALDLLFLDFFFFFFFDSAFDAFDAFASFDSL'
    }],
    'province': '广东省',
    'province_code': '140000',
    'sub_channel_type': 3
  },
  'message': 'ok'
})

// 今日线索任务
Mock.mock(/sale_potential_customer\/today_clue_tasks/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'tasks': [
      {
        'customer_name': '哇哈哈111',
        'id': 1,
        'intention_cars': [
          {
            'car_model': '111',
            'inner_color': '黑色',
            'outer_color': '红色'
          }
        ],
        'last_contact_at': '2017-10-17 10:30:33',
        'mobile': '15002056658',
        'next_arrive_at': '2017-10-17 10:30:33',
        'next_contact_at': '2017-10-17'
      }, {
        'customer_name': '哇哈哈222',
        'id': 2,
        'intention_cars': [
          {
            'car_model': '111',
            'inner_color': '黑色',
            'outer_color': '红色'
          }
        ],
        'last_contact_at': '2017-10-17 10:30:33',
        'mobile': '15002056658',
        'next_arrive_at': '2017-10-17 10:30:33',
        'next_contact_at': '2017-10-17'
      }, {
        'customer_name': '哇哈哈222',
        'id': 2,
        'intention_cars': [
          {
            'car_model': '111',
            'inner_color': '黑色',
            'outer_color': '红色'
          }
        ],
        'last_contact_at': '2017-10-17 10:30:33',
        'mobile': '15002056658',
        'next_arrive_at': '2017-10-17 10:30:33',
        'next_contact_at': '2017-10-17'
      }, {
        'customer_name': '哇哈哈222',
        'id': 2,
        'intention_cars': [
          {
            'car_model': '111',
            'inner_color': '黑色',
            'outer_color': '红色'
          }
        ],
        'last_contact_at': '2017-10-17 10:30:33',
        'mobile': '15002056658',
        'next_arrive_at': '2017-10-17 10:30:33',
        'next_contact_at': '2017-10-17'
      }, {
        'customer_name': '哇哈哈222',
        'id': 2,
        'intention_cars': [
          {
            'car_model': '111',
            'inner_color': '黑色',
            'outer_color': '红色'
          }
        ],
        'last_contact_at': '2017-10-17 10:30:33',
        'mobile': '15002056658',
        'next_arrive_at': '2017-10-17 10:30:33',
        'next_contact_at': '2017-10-17'
      }
    ],
    'total': 110
  },
  'message': 'ok'
})

// 全部线索任务
Mock.mock(/sale_potential_customer\/clue_tasks/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'tasks': [
      {
        'customer_name': '哇哇哇啊0',
        'id': 1,
        'intention_cars': [
          {
            'car_model': '宝马',
            'inner_color': '黑色',
            'outer_color': '红色'
          },
          {
            'car_model': '宝马',
            'inner_color': '黑色',
            'outer_color': '红色'
          }
        ],
        'last_contact_at': '2017-10-17 10:30:33',
        'mobile': '15002056658',
        'next_arrive_at': '2017-10-17 10:30:33',
        'next_contact_at': '2017-10-17'
      },
      {
        'customer_name': '哇哇哇啊1',
        'id': 2,
        'intention_cars': [
          {
            'car_model': '宝马',
            'inner_color': '黑色',
            'outer_color': '红色'
          },
          {
            'car_model': '宝马',
            'inner_color': '黑色',
            'outer_color': '红色'
          }
        ],
        'last_contact_at': '2017-10-17 10:30:33',
        'mobile': 'string',
        'next_arrive_at': '2017-10-17 10:30:33',
        'next_contact_at': '2017-10-17'
      }, {
        'customer_name': '哇哇哇啊2',
        'id': 3,
        'intention_cars': [
          {
            'car_model': '宝马',
            'inner_color': '黑色',
            'outer_color': '红色'
          },
          {
            'car_model': '宝马',
            'inner_color': '黑色',
            'outer_color': '红色'
          }
        ],
        'last_contact_at': '2017-10-17 10:30:33',
        'mobile': 'string',
        'next_arrive_at': '2017-10-17 10:30:33',
        'next_contact_at': '2017-10-17'
      }
    ],
    'total': 100
  },
  'message': 'ok'
})

// 全部线索
Mock.mock(/sale_potential_customer\/clues/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'clues': [
      {
        'customer_name': '拜拜拜拜拜拜3',
        'id': 3,
        'intention_cars': [
          {
            'car_model': 'string',
            'inner_color': 'string',
            'outer_color': 'string'
          }
        ],
        'last_contact_at': '2016-10-17 10:30:33',
        'mobile': 'string',
        'next_arrive_at': '2016-10-17 10:30:33',
        'next_contact_at': '2016-10-17'
      },
      {
        'customer_name': '拜拜拜拜拜拜1',
        'id': 1,
        'intention_cars': [
          {
            'car_model': 'string',
            'inner_color': 'string',
            'outer_color': 'string'
          }
        ],
        'last_contact_at': '2016-10-17 10:30:33',
        'mobile': 'string',
        'next_arrive_at': '2016-10-17 10:30:33',
        'next_contact_at': '2016-10-17'
      }, {
        'customer_name': '拜拜拜拜拜拜2',
        'id': 2,
        'intention_cars': [
          {
            'car_model': 'string',
            'inner_color': 'string',
            'outer_color': 'string'
          }
        ],
        'last_contact_at': '2016-10-17 10:30:33',
        'mobile': 'string',
        'next_arrive_at': '2016-10-17 10:30:33',
        'next_contact_at': '2016-10-17'
      }, {
        'customer_name': '拜拜拜拜拜拜2',
        'id': 2,
        'intention_cars': [
          {
            'car_model': 'string',
            'inner_color': 'string',
            'outer_color': 'string'
          }
        ],
        'last_contact_at': '2016-10-17 10:30:33',
        'mobile': 'string',
        'next_arrive_at': '2016-10-17 10:30:33',
        'next_contact_at': '2016-10-17'
      }, {
        'customer_name': '拜拜拜拜拜拜2',
        'id': 2,
        'intention_cars': [
          {
            'car_model': 'string',
            'inner_color': 'string',
            'outer_color': 'string'
          }
        ],
        'last_contact_at': '2016-10-17 10:30:33',
        'mobile': 'string',
        'next_arrive_at': '2016-10-17 10:30:33',
        'next_contact_at': '2016-10-17'
      }
    ],
    'total': 1010
  },
  'message': 'ok'
})

// 通过手机号码查找客户信息
Mock.mock(/sale_potential_customer\/search_customer_by_mobile/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'clue': {
      'address': 'string',
      'channel_type': 0,
      'city': 'string',
      'city_code': 'string',
      'contrast_cars': [
        {
          'model_id': 0,
          'model_name': 'string'
        }
      ],
      'creator': 'string',
      'customer_name': 'string',
      'district': 'string',
      'district_code': 'string',
      'from_type': 0,
      'id': 1,
      'intention_cars': [
        {
          'car_model': {
            'id': 0,
            'name': 'string'
          },
          'inner_color': 0,
          'outer_color': 0
        }
      ],
      'mobile': 'string',
      'next_arrive_at': '2016-10-17 10:30:33',
      'next_contact_at': '2016-10-17',
      'notes': [
        {
          'created_at': '2016-10-17 10:30:33',
          'remark': 'string'
        }
      ],
      'priority': 0,
      'province': 'string',
      'province_code': 'string',
      'sub_channel_type': 0,
      'user_type': 0
    },
    'customer': {
      'address': 'string',
      'channel_type': 0,
      'city': 'string',
      'city_code': 'string',
      'contrast_cars': [
        {
          'car_model_id': 0,
          'car_model_name': 'string'
        }
      ],
      'creator': 'string',
      'customer_name': 'string',
      'district': 'string',
      'district_code': 'string',
      'first_arrive_at': '2017-10-17 10:30:33',
      'first_arrive_type': 0,
      'id': 1,
      'intention_cars': [
        {
          'car_model_id': 0,
          'car_model_name': 'string',
          'inner_color': 0,
          'outer_color': 0
        }
      ],
      'intention_level': 'string',
      'last_contact_at': '2017-10-17 10:30:33',
      'mobile': 'string',
      'next_arrive_at': '2017-10-17 10:30:33',
      'next_contact_at': '2017-10-17',
      'province': 'string',
      'province_code': 'string',
      'sub_channel_type': 0
    }
  },
  'message': 'ok'
})

// 今日客户任务(任务)
Mock.mock(/sale_potential_customer\/customer_tasks/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'tasks': [
      {
        'call_count': 10,
        'customer_name': 'string',
        'day_to_expire': 10,
        'id': 10,
        'intention_cars': [
          {
            'car_model': 'string',
            'inner_color': 'string',
            'outer_color': 'string'
          }
        ],
        'intention_level': 'string',
        'is_complete': true,
        'last_contact_at': '2017-10-17 10:30:33',
        'mobile': 'string',
        'next_arrive_at': '2017-10-17 10:30:33',
        'next_contact_at': '2017-10-17',
        'sequence': 10,
        'total_task_count': 10
      },
      {
        'call_count': 110,
        'customer_name': 'string',
        'day_to_expire': 110,
        'id': 110,
        'intention_cars': [
          {
            'car_model': 'string',
            'inner_color': 'string',
            'outer_color': 'string'
          }
        ],
        'intention_level': 'A',
        'is_complete': false,
        'last_contact_at': '2017-10-17 10:30:33',
        'mobile': '15002056658',
        'next_arrive_at': '2017-10-17 10:30:33',
        'next_contact_at': '2017-10-17',
        'sequence': 10,
        'total_task_count': 10
      },
      {
        'call_count': 10,
        'customer_name': 'string',
        'day_to_expire': 10,
        'id': 10,
        'intention_cars': [
          {
            'car_model': 'string',
            'inner_color': 'string',
            'outer_color': 'string'
          }
        ],
        'intention_level': 'string',
        'is_complete': true,
        'last_contact_at': '2017-10-17 10:30:33',
        'mobile': 'string',
        'next_arrive_at': '2017-10-17 10:30:33',
        'next_contact_at': '2017-10-17',
        'sequence': 10,
        'total_task_count': 10
      },
      {
        'call_count': 110,
        'customer_name': 'string',
        'day_to_expire': 110,
        'id': 110,
        'intention_cars': [
          {
            'car_model': 'string',
            'inner_color': 'string',
            'outer_color': 'string'
          }
        ],
        'intention_level': 'A',
        'is_complete': false,
        'last_contact_at': '2017-10-17 10:30:33',
        'mobile': '15002056658',
        'next_arrive_at': '2017-10-17 10:30:33',
        'next_contact_at': '2017-10-17',
        'sequence': 10,
        'total_task_count': 10
      },
      {
        'call_count': 10,
        'customer_name': 'string',
        'day_to_expire': 10,
        'id': 10,
        'intention_cars': [
          {
            'car_model': 'string',
            'inner_color': 'string',
            'outer_color': 'string'
          }
        ],
        'intention_level': 'string',
        'is_complete': true,
        'last_contact_at': '2017-10-17 10:30:33',
        'mobile': 'string',
        'next_arrive_at': '2017-10-17 10:30:33',
        'next_contact_at': '2017-10-17',
        'sequence': 10,
        'total_task_count': 10
      },
      {
        'call_count': 110,
        'customer_name': 'string',
        'day_to_expire': 110,
        'id': 110,
        'intention_cars': [
          {
            'car_model': 'string',
            'inner_color': 'string',
            'outer_color': 'string'
          }
        ],
        'intention_level': 'A',
        'is_complete': false,
        'last_contact_at': '2017-10-17 10:30:33',
        'mobile': '15002056658',
        'next_arrive_at': '2017-10-17 10:30:33',
        'next_contact_at': '2017-10-17',
        'sequence': 10,
        'total_task_count': 10
      },
      {
        'call_count': 10,
        'customer_name': 'string',
        'day_to_expire': 10,
        'id': 10,
        'intention_cars': [
          {
            'car_model': 'string',
            'inner_color': 'string',
            'outer_color': 'string'
          }
        ],
        'intention_level': 'string',
        'is_complete': true,
        'last_contact_at': '2017-10-17 10:30:33',
        'mobile': 'string',
        'next_arrive_at': '2017-10-17 10:30:33',
        'next_contact_at': '2017-10-17',
        'sequence': 10,
        'total_task_count': 10
      },
      {
        'call_count': 110,
        'customer_name': 'string',
        'day_to_expire': 110,
        'id': 110,
        'intention_cars': [
          {
            'car_model': 'string',
            'inner_color': 'string',
            'outer_color': 'string'
          }
        ],
        'intention_level': 'A',
        'is_complete': false,
        'last_contact_at': '2017-10-17 10:30:33',
        'mobile': '15002056658',
        'next_arrive_at': '2017-10-17 10:30:33',
        'next_contact_at': '2017-10-17',
        'sequence': 10,
        'total_task_count': 10
      }
    ],
    'total': 100
  },
  'message': 'ok'
})
// 今日客户任务(客户)
Mock.mock(/sale_potential_customer\/today_pending_contact_customer/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'customers': [
      {
        'customer_name': 'bbbbbb',
        'id': 1,
        'intention_cars': [
          {
            'car_model': 'string',
            'inner_color': 'string',
            'outer_color': 'string'
          }
        ],
        'intention_level': 'A',
        'last_contact_at': '2017-10-17 10:30:33',
        'mobile': '15002056659',
        'next_arrive_at': '2017-10-17 10:30:33',
        'next_contact_at': '2017-10-17'
      }, {
        'customer_name': 'cccccc',
        'id': 2,
        'intention_cars': [
          {
            'car_model': 'string',
            'inner_color': 'string',
            'outer_color': 'string'
          }
        ],
        'intention_level': 'B',
        'last_contact_at': '2017-10-17 10:30:33',
        'mobile': '15002056658',
        'next_arrive_at': '2017-10-17 10:30:33',
        'next_contact_at': '2017-10-17'
      }
    ],
    'total': 200
  },
  'message': 'ok'
})
// 全部客户
Mock.mock(/sale_potential_customer\/customers/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'customers': [
      {
        'customer_name': 'eeee1',
        'id': 1,
        'intention_cars': [
          {
            'car_model': 'string',
            'inner_color': 'string',
            'outer_color': 'string'
          }
        ],
        'intention_level': 'string',
        'last_contact_at': '2017-10-17 10:30:33',
        'mobile': 'string',
        'next_arrive_at': '2017-10-17 10:30:33',
        'next_contact_at': '2017-10-17'
      },
      {
        'customer_name': 'eeee2',
        'id': 2,
        'intention_cars': [
          {
            'car_model': 'string',
            'inner_color': 'string',
            'outer_color': 'string'
          }
        ],
        'intention_level': 'string',
        'last_contact_at': '2017-10-17 10:30:33',
        'mobile': 'string',
        'next_arrive_at': '2017-10-17 10:30:33',
        'next_contact_at': '2017-10-17'
      },
      {
        'customer_name': 'string',
        'id': 3,
        'intention_cars': [
          {
            'car_model': 'string',
            'inner_color': 'string',
            'outer_color': 'string'
          }
        ],
        'intention_level': 'string',
        'last_contact_at': '2017-10-17 10:30:33',
        'mobile': 'string',
        'next_arrive_at': '2017-10-17 10:30:33',
        'next_contact_at': '2017-10-17'
      }
    ],
    'total': 0
  },
  'message': 'ok'
})
// 客户统计
Mock.mock(/sale_potential_customer\/customer_statistics/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'deal_num': 10,
    'fail_num': 20,
    'total_num': 30
  },
  'message': 'ok'
})
// 购车意向
Mock.mock(/sale_potential_customer\/store_brands/, 'get' + mockSwitch,
  {
    'code': 0,
    'data': [
      {
        'icon': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_9_55.png',
        'id': 350000,
        'initial': 'A',
        'name': '奥迪'
      },
      {
        'icon': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_9_55.png',
        'id': 350000,
        'initial': 'A',
        'name': '奥迪'
      },
      {
        'icon': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_9_55.png',
        'id': 350000,
        'initial': 'A',
        'name': '奥迪'
      },
      {
        'icon': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_9_55.png',
        'id': 350000,
        'initial': 'A',
        'name': '奥迪'
      }
    ],
    'message': 'ok'
  }
)
